module.exports = __webpack_public_path__ + "img/logo.60e42c80.png";